const { Fragment } = require("react");
import React from "react";
module.exports = {
  ALL_CONSTANTS: {
    ACCOUNT_NUMBER_CONST: "Account Number",
    MOBILE_NUMBER_CONST: "Mobile Number",
    PAN_NUMBER_CONST: "Permanent Account Number (PAN)",
    DOB_CONST: "Date of Birth (DoB)",
    UPDATE_EMAIL_ID: "Email Id",
    Update_Employer_Name: "Employer Name",
    UPDATE_PAN: "Permanent Account Number (PAN)",
    LOADING: "LOADING ...",
    UPDATE_ADDRESS: "Address",
    UPDATE_RE_KYC: "Update Re-KYC",
    BLOCK_DEBIT: "Block ATM/Debit card",
    BLOCK_CREDIT: "Block Credit card",
    BLOCK_CHEQUE: "Block Cheque",
    OVERDUETYPE: "OVERDUE",
    BLUE: "#101d6c",
    GSTIN_PREVIEW: 'Please preview the document to proceed',
    CSP_CHANNELS:['CSP-IMOBILE','VRM', 'CIB' ,'INSTABIZ','RIB','IVIEW','BOTM'],


    //NewOverdue_Verification_Screen
    OTP_HEADER:
      'One-Time password has been sent on your registered mobile number and Email-id.',
    GET_STARTED_TEXT: 'To get you started, select any one ',
    GET_STARTED: 'Let us get started',
    DOB_NUDGE: 'Keep your PAN or Account number handy',
    PHONE_NUDGE: 'Keep your PAN handy',
    ENTER_MOB_NUMBER: 'Identification by Mobile Number',
    PAN_HEADER: 'To complete your login, enter your PAN number',
    ACCOUNT_HEADER: 'To complete your login, enter your PAN or Account number',
    PAN_VALUE: 'PAN Number',
    WELCOME_HEADER: 'Welcome to the DIY portal!',
    DATE_OF_BIRTH: 'Identification by Date of birth (DOB)',
    DIY_LOGIN_TERMS:
      'By submitting my details, I override my DNC/NDNC registration and authorise ICICI Bank and its representatives to contact me through call, WhatsApp, SMS, other messaging apps, social media platforms or e-mail. I further consent to share my information on confidential basis with third parties for evaluating and processing this proposal. ICICI Bank will be sending OTP on the registered mobile number and / or E-mail ID. ',

    //NewOverdue_Screen
    WELCOME: 'Welcome',
    OVERDUE_ACCOUNT: 'Overdue Account',
    TOTAL_OVERDUE_AMOUNT: ' Total overdue amount',
    INTEREST_OVERDUE: 'Interest overdue',
    OVERDUE: 'Overdue',
    MY_DUES: 'My dues at a glance',
    EMI: 'EMI overdue',
    OVERDUE_AMOUNT: ' Overdue Amount',
    INTEREST_PAYABLE: 'Outstanding / Interest overdue',
    MY_DUE: 'My dues at a glance',
    VIEW_CIBIL: 'View CIBIL score',
    AMOUNT_PAYABLE: 'Amount Payable',
    MONTHLY_EMI_AMOUNT: 'Monthly EMI amount',
    LOAN_SERVICE_TEXT: 'Cannot find what you are looking for?',
    LOAN_SERVICE_SUB_TEXT:
      'For more information, visit the nearest ICICI Bank Loan Servicing Branch.',
    NO_OVERDUE:' Information is not available for the authenticated mobile number. For more information, call our Customer Care on 1800 1080.',
    //PQ_Offer
    ACCOUNT_CLOSURE: "Account Closure",
    PRE_HEADER:
      "Save on additional interest and charges with immediate account closure",
    SETTLEMENT_AMOUNT: "Settlement Amount",
    CLOSURE_AMOUNT: "Total Closure Amount",
    TOTAL_AMOUNT_PAYBLE: "Total Amount Payable",
    CUSTOMER_NAME: "Customer Name",
    LOAN_TYPE: "Type of loan",
    SETTLE_AN_ACCOUNT: "Settle an Account",
    CLOSE_AN_ACCOUNT: "Close an Account",
    ACCOUNT_NUMBER: "Account Number",
    VEHICLE_NUMBER: "Vehicle Registration Number",
    PRODUCT_NAME: "Product Name",
    AMOUNT_ALERTS: "Reduce the interest charges by selecting ‘Full Pay’",
    TERMS_CONDITION: "Terms and conditions",
    TERMS_SETTLEMENT_TEXT:
      " I confirm the above Settlement details and agree to the",
    TERMS_CLOSURE_TEXT:
      " I confirm the above details applicable for  Closure of the account and agree to the",
      DECLARATION1:'I/We understand that Bank is relying on this information for determining my status in FATCA/CRS compliance and understand that the Bank is unable to offer any tax advice or FATCA/CRS status or its impact.',
      DECLARATION2:'I / We agree to submit a new form within 30 days if any certification or information in the FATCA/CRS becomes incorrect.',
      DECLARATION3:'I am further aware that as per the Union Budget, 2023, a penalty of Rs. 5,000 per account holder shall be levied for furnishing inaccurate statement of financial transaction owing to false or inaccurate self-certification submitted by me under FATCA/CRS',
      OUTSIDE_INDIA:'Since you are tax resident of country outside India or an US Person, please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details',
      OTP_FAILED_THRICE_GENERIC:
        'OTP failed! Kindly visit nearest ICICI Bank Branch or contact customer care for more details',    
    POP_UP:
      " If you are using Safari browser, for better user experience request you to allow few settings. {`\n`}- Go to phone Settings, {`\n`}- Select the 'Safari' tab, {`\n`}- Under Privacy & Security section do the following setting, {`\n`} 1. Prevent Cross- Site Tracking : OFF,{`\n`} 2. Block all Cookies: OFF",
    NOW_PAYING: "Now Paying",
    NO_PQ_CONTENT:
      "Currently there are no online plans available. Please check with your Relationship Manager for details. ",
    FIRST_NUDGE_MESSAGE:
      "Minimal chances of approval. Please select bigger amount",
    SECOND_NUDGE_MESSAGE:
      "To maximise your chances of approval, choose a bigger amount",
    THIRD_NUDGE_MESSAGE: "Great! You have high chances of approval",
    PAYMENT_STATUS: "You have successfully paid",
    SETTLEMENT_ID_MESSAGE:
      "Payment completed on time helps to save an additional charges and interests. Pay now!",
    SETTLEMENT_PAY_NUDGE:
      "You need to clear your closure amount on or before Settlement validity date",
    INSTALLMENT_MESSAGE:
      "Your total amount payable will change based on the installment selected",
    TERMS_AND_CONDITIONS: {
      TERM_1:
        "The pre-qualified settlement offer displayed on the web portal is available for a limited period only. The Bank has the right to withdraw it at any point of time without any prior notice, and this cannot be disputed.",
      TERM_2:
        "Time is of essence of this offer and therefore the settlement amount offered is to be paid as per the timelines in accordance with the terms and conditions agreed upon in the settlement letter and any failure to adhere to the said terms and conditions will result in the settlement offer becoming null & void.",
      TERM_3:
        "The payment made through this web portal will be duly updated in your respective Loan/Credit Card Account within 3 working days.",
      TERM_4:
        "Once the settlement amount is received, within the stipulated timeline as per the settlement letter, the respective Loan/Credit Card against which the settlement is offered will be settled and closed in the bank records.",
      TERM_5:
        "The customer agrees that the status of the Loan/Credit Card Account will be updated as 'Settled' with Credit Bureaus such as Transunion CIBIL, Experian, CRIF, Highmark & Equifax.",
      TERM_6:
        "Any amount paid towards the settlement shall not be refunded under any circumstances. Even in the event of the settlement letter becoming null & void, the paid amount will be adjusted against the total outstanding dues.",
      TERM_7:
        "The customer will also have the option to pay the complete foreclosure amount instead of the settlement amount, in case the customer wishes to pay the total outstanding amount. On payment of the foreclosure amount, account status will be updated as 'Zero Dues' with credit bureaus such as Transunion CIBIL, Experian, CRIF, Highmark & Equifax.",
      TERM_8:
        "In case if you wish to continue making the payment in the Loan/Credit Card Account or wish to pay the entire foreclosure amount after generation of the settlement letter, then you will be required to inform the Bank about the same in a timely manner.",
      TERM_9:
        "You are required to share a valid transaction ID and/or settlement letter with the Bank's authorised collection agency, in case any contact is made by the collection agency for repayment of outstanding dues.",
      TERM_10:
        "The customer has to ensure that there is proper internet connectivity prior to making any payment. The Bank will not be responsible for any failure of payment due to connectivity issues or any other reason whatsoever, which is beyond the control of the Bank.",
      TERM_11:
        "The Bank has absolute right to withdraw the settlement offer at any point of time due to any policy change by the Bank/regulator/government bodies without any prior intimation to the customer.",
      TERM_12:
        "In compliance with the RBI guidelines, if the settlement is approved, the linked accounts of the customers may be categorised as Non-Performing Assets (NPA), and this information will be reported to Credit Bureaus. This rule also applies to the current situation.",
      TERM_13:
        "For non-classification of linked accounts as NPA, if any, you will be required to pay the waived-off amount along with applicable charges. You will be required to contact Bank officials to know the exact amount to be paid for changing NPA classification.",
      TERM_14:
        "Once the settlement letter is generated, it will be deemed as final and no further amendment or modification can be made to the same.",
      TERM_15:
        "The Bank will not entertain any dispute related to the usage of the web portal.",
      TERM_16:
        "In case you have opted for payment of the settlement amount in multiple instalments, then the payment from second instalment onwards will have to be made via digital channels like UPI/NEFT/RTGS or by visiting asset servicing branches. The web portal will not support payment from the second instalment onwards.",
      TERMS_17: (
        <Fragment>
          {" "}
          <b>Legal cases/complaints : </b>It is agreed that you as well as the
          Bank will take necessary steps to withdraw the legal cases/complaints,
          if any, filed against each other (including officials/associates of
          the Bank) relating to or arising from the subject matter of settlement
          by filing the said letter as consent terms before the
          courts/forums/tribunals after adhering to the terms mentioned herein
        </Fragment>
      ),
      TERMS_18: (
        <Fragment>
          {" "}
          <b>Credit bureau records : </b> Your credit history available with us
          is provided on a regular basis to CIBIL and other credit bureaus, an
          initiative of the Government of India and the Reserve Bank of India.
          On payment of the agreed amount, your status will be updated as
          'Settled' in CIBIL or other credit bureau records, within 60 days from
          the closure of the facility in the Bank’s records if you opt for the
          “Settlement” of your dues. This means you are paying an amount which
          is less than the amount required for closure of the facility. In case
          you choose to pay the entire closure amount, your status will be
          updated as 'Zero Dues' in CIBIL or other credit bureau records within
          60 days from the closure of the facility in the Bank’s records.
        </Fragment>
      ),
      TERMS_19: (
        <Fragment>
          <b>Default in payments : </b>In case of any default committed by you
          in the agreed payment schedule or in the event the cheque(s) issued by
          you is/are dishonoured on or after the date of this letter, for
          whatever reasons, this offer shall stand null, void and withdrawn.
          Further, all the concessions granted shall also stand withdrawn. In
          such circumstances, you shall be liable to pay the entire outstanding
          amount as per the statement of account at once. The Bank may then be
          entitled to take appropriate measures to recover the entire
          outstanding dues by initiating both civil and criminal proceedings as
          per the terms and conditions of this letter as well as the terms of
          the facility.
        </Fragment>
      ),
      TERMS_20: (
        <Fragment>
          <b>Outstanding dues on other credit facility(s)/cards : </b>In case
          you have taken any other credit facility(s)/stood as a guarantor for
          any credit facility(s) from the bank which has outstanding dues, then
          the bank will be within its rights to withhold the "No Dues
          Certificate/No Objection Certificate" and related documents for the
          said credit facility, till such time all pending dues are paid by you
          or the principal borrower to the Bank
        </Fragment>
      ),
      TERMS_21: (
        <Fragment>
          <b>Payment through Collection Agency : </b>In case the payments are
          made through a Collection Agency, please ensure that payment
          acknowledgement receipt has been received by you through SMS and/or
          e-mail. You are also advised to keep the payment acknowledgement
          receipt securely for future reference. Also, kindly check the ID Card
          of the agent issued by the Bank before making any payment. The Bank
          will not be responsible in an event the payment has been made to an
          unauthorised agent.
        </Fragment>
      ),
    },

    // remove this once updated
    RADIO: "Radio",
    MULTIRADIO: "multiRadio",
    PAN: "Pan",
    GST: "GSTin",
    SRNUM: "SRNum",
    SLIDER: "multiSlider",
    MULTI_FAMILY_BANKING: "multiFamilyBanking",
    MULTI_KYC_PROFILE_UPDATE: "kycProfileUpdate",
    PIN: "pin",
    CONFIRMPIN: "confirmPin",
    EMAIL: "Email",
    TEXTINPUT: "Textinput",
    TEXTAREA: "Textarea",
    DROPDOWN: "dropdown",
    DROPDOWNSEARCH: "dropdownsearch",
    MULTICHECK: "multiCheck",
    AUTO_COMPLETE: "autocomplete",
    MODAL: "modal",
    CREDIT_CARD: "creditCard",
    DEBIT_CARD: "debitCard",
    CHEQUE: "cheque",
    PASSPORT: "passport",
    PREVIEW: "PREVIEW",
    DELETE_TEXT: "DELETE",

    // pebble
    PEBBLEURL_VARIANT: "/servicing/pebble-services/variant-migration",
    PEBBLEURL_SOLVENCY: "/servicing/pebble-services/solvency-certificate",
    PEBBLEURL_BANKINGKYC: "/servicing/pebble-services/banking-kyc",
    PEBBLEURL_EMAIL: "/servicing/pebble-services/email-mobile-modification",
    PEBBLEURL_DEMOG: "/servicing/pebble-services/demogUpdate",
    PEBBLEURL_PAYSLIP: "/servicing/pebble-services/payslip",
    //pebble-end

    ACCOUNT_NUMBER: "Account Number",
    MOBILE_NUMBER: "MobileNumber",
    DATE: "date",
    UPLOAD: "upload",
    MULTI_UPLOAD: "Multi_upload",
    DOWNLOAD: "download",
    PINCODE: "pincode",
    NUMBER_INPUT: "NumberTextinput",

    DECLARATION: "declaration",
    SORRYTEXT: "Sorry, ",
    USERVERIFICATIONFAILED:
      "The details which you have entered do not match with our records. Please check the details and try again",
    OTPLIMITERROR: "You have exceeded the maximum number of tries, Thank you!",

    AADHAROTPFAILED:
      "The OTP which you have entered is invalid. Please enter a valid OTP and try again",
    AUTHENTICATIONFAILED: "Invalid OTP. Please try again.",
    INVALIDOTP: "Authentication failed. Please try again.",
    CLICKONRESEND: "Click on Resend Button To Generate New Otp",
    PAYNOW: "Pay Now",
    GOBACK: "Go Back",
    ACCTNO: "Account Number",
    DENY: "Deny",
    CANCEL: "Cancel",
    CONFIRM: "Confirm",
    CONTINUE_TEXT: "Continue",
    SERVICE_STATUS: "Service not Available",
    OK: "Ok",
    AUTODEBITNOTE_1:
      "1.  I hereby authorize ICICI bank to change my repayment mode to auto debit",
    AUTODEBITNOTE_2:
      "2.  I agree and acknowledge that the said account can be used for security mandate and can be used by ICICI bank to recover the outstanding  loan amount.",
    AUTODEBITNOTE_3:
      "3.  I understand that, if immediate EMI cycle is already in process for clearance/payment, then change in the repayment mode shall become effective from subsequent cycle date which will be communicated to me through SMS.",
    AUTODEBITNOTE_4:
      "4.  I understand that change of repayment mode is not permissible for Lease Rental Discounting, Lease Rental Discounting Overdraft, Construction-Linked Builder scheme, Loan againts Property for Educational Institutions, Overdraft & Reimbursement Current Accounts (or any other Escrow repayment account) cases.",
    VERIFYDETAILS: "Please verify and Confirm your details",
    WAITINGFORCUSTOMER: " Waiting for Customer confirmation.",
    PLSCLICKRESEND:
      'Please click on "Resend Link" for sending verification link to customer again.',
    WAITING:
      "Verification link has been sent to Customer's registered mobile number.",
    PLEASEWAIT: "Please wait.....",
    THANKYOURESPONSE: "Thank You for your response",
    YOURREQUEST: "Your request for service has been processed...",
    PROCESSTERMINATED: "Process has been terminated.....Please retry again",
    PLEASECONFIRM: "Please Confirm...",
    PlEASECLOSE: "Happy to serve you. Please close the window.",
    DOB_FILE_SIZE_HEADING: 'Notes :',
    DOB_FILE_SIZE_MESSAGE1: '1. File size not to exceed 512 KB and should be in JPG/JPEG/TIFF/PNG/PDF format only.',
    DOB_FILE_SIZE_MESSAGE2: '2. The attachment should not be password-protected.',
    DOB_FILE_SIZE_MESSAGE3: '3. File name should neither exceed 40 characters nor include %,@,<,>,*,# or any type of brackets.',
    PAN_MSG : [
      '1. File size not to exceed 1 MB and should be in JPG/JPEG/TIFF/PNG/PDF format only.',
      '2. The attachment should not be password-protected.',
      '3. File name should neither exceed 40 characters nor include %,@,<,>,*,# or any type of brackets.'
      ],
    ADHAAR_PASSPORT_MSG : [
      '1. File size not to exceed 512 KB and should be in JPG/JPEG/TIFF/PNG/PDF format only.',
      '2. The attachment should not be password-protected.',
      '3. File name should neither exceed 40 characters nor include %,@,<,>,*,# or any type of brackets.'
    ],
    REKYCSUCCESS: "RE-KYC is successful",
    REKYCFAILED:
      "Sorry, your transaction could not be processed, please try again later",
    CANCELLEDBYUSER:
      "Customer approval not received. Please re-initiate the request.",
    EMAIL_UPDATE_NOTE:
      "Incase of change in Email ID, same will be updated in account(s).",
    GRID_ATTEMPT_MESSAGE:
      "You have exceeded the maximum number of attempts to enter the correct Debit Grid details. Please try again.",
    GRID_ERROR_MESSAGE: "Please enter valid grid Card details",

    // path
    PROFILE_PATH: "/servicing/profile",
    ACCOUNT_PATH: "/servicing/accounts",
    CREDIT_CARD_PATH: "/servicing/creditcards",
    LOAN_PATH: "/servicing/loans",
    DEPOSITS_PATH: "/servicing/deposits",
    INVESTMENT_PRODUCT_PATH: "/servicing/investmentProducts",
    FOREX_PATH: "/servicing/forex",

    DGOV_SERVICE_PROCESS_URL: "/servicing/data-governance-process",
    DUALRES_SERVICE_PROCESS_URL: "/servicing/dual-residency-process",
    DUE_PATH: "/servicing/due",
    DUE_VERIFICATION_PATH: "/servicing/due/Verification",
    // DUE_VERIFICATION_PATH: "/servicing/due/Verification",
    ATMDEBIT_PATH: "/servicing/debit",
    AGENT_PATH: "/servicing/agent-login",
    PROFILEVERIFY_PATH: "/servicing/profile/verifyUser",
    ACCOUNTVERIFY_PATH: "/servicing/accounts/verifyUser",
    CREDITVERIFY_CARD_PATH: "/servicing/creditcards/verifyUser",
    LOANVERIFY_PATH: "/servicing/loans/verifyUser",
    DEPOSITSVERIFY_PATH: "/servicing/deposits/verifyUser",
    INVESTMENT_PRODUCTVERIFY_PATH: "/servicing/investmentProducts/verifyUser",
    FOREX_PATHVERIFY: "/servicing/forex/verifyUser",

    OTHERURL_PATH: "/servicing/agent-service",

    //url end
    PROFILE_URL_END: "/profile",
    ACCOUNT_URL_END: "/accounts",
    CREDIT_CARD_URL_END: "/creditcards",
    LOAN_URL_END: "/loans",
    DEPOSITS_URL_END: "/deposits",
    INVESTMENT_PRODUCT_URL_END: "/investmentProducts",
    FOREX_URL_END: "/forex",
    DUE_URL_END: "/due",
    // DUE_URL_VERIFICATION_END: "/due",
    DEBIT_URL_END: "/debit",

    VERIFY: "/verifyUser",
    OTHERURL_END: "/agent-service",

    // service heading
    PROFILE_HEADING: "Profile Update Requests",
    ACCOUNT_HEADING: "Account Requests",
    CREDIT_CARD_HEADING: "Credit Card Requests",
    LOAN_HEADING: "Loan Requests",
    DEPOSITS_HEADING: "Deposit Requests",
    INVESTMENT_PRODUCT_HEADING: "Investments Product Requests",
    FOREX_HEADING: "Forex Requests",
    DEBIT_HEADING: "ATM/Debit Card Request",
    // validation error messages
    DATEVALIDATION:
      "The end date which you have entered cannot be prior to or same as the start date. Please check the end date and try again.",
    RESEND_LINK: "Resend Link",
    PANERROR:
      "PAN already updated in your Savings/Current Account. To replace existing PAN in your account, please visit nearest branch with original new PAN card and acknowledgement of the letter submitted to the IT authorities for surrender of PAN.",
    ENTERCORRECTDOB:
      "Please enter correct Date of Birth as the age should be less than 60.",
    CHEQUEERROR: "Cheque number should be greater than ",
    FAILEDTOUPLOAD: "Failed to Upload.Please try again..",
    SOMEWENTWRONG: "Something went wrong",
    INVALID_CREDS:"The details which you have entered do not match with our records. Please check the details and try again. Alternatively, contact Customer Service on 022-39337910. Thank you. ",
    INVALID_C360:"Please update your latest mobile number for all the ICICI bank relationships. Alternatively, contact Customer Service on 022-39337910. Thank you.",
    INVALIDPAN: "Invalid Pan Number",
    INVALIDACCOUNTNO: "Invalid Account Number",
    SOMETHINGWENTWRONG: "Something went Wrong, Please try again after sometime",
    PANNUMBERANDNAME:"Dear customer, We are unable to proceed ahead due to PAN Number is not available.",
    UNABLETOFETCHDATA:'We are unable to fetch you data. Please try again later',

    INVALIDPINCODE: "Invalid Pin Code",
    INVALIDLOANNO: "Invalid Loan Number",
    NONOMINEETEXT:
      "No nominee is registered in this account. Please register nominee & choose this account or choose another account.",
    NONOMINEE:
      'No nominee is registered on this account. Click on "Next" to add nominee.',
    PLEASEENTERNEWACCNO: "Please enter new account number",
    PlEASESELECTNEWACCOUNT: "Account is already linked to the selected card",
    DATEOFPANERROR:
      "Date of PAN acknowledgement cannot be greater than 90 days",
    STATEERR: "State does not match with GSTIN entered by you",
    PLEASEENTERNEWEMAIL: "Please enter new Email ID",
    PLSENTRNEWGST: "Please enter new GSTIN",
    PLSENTERAMT: "Please enter amount between",

    AMTERROR:
      "The amount should be in multiples of 50. Please enter a valid amount to proceed.",
    PASSWORDERR: "assword should contain at least 8 characters",
    PASSWRDNOTMATCH: "Password doesnt match",
    STATEGST: "State does not match with GSTIN entered by you",
    PERMNTBLOCK:
      "Please Note : Permanently blocked card cannot be activated again.",
    PLSENTERFILED: "Please enter field",
    SELECTVALIDBILLINGCYCLE:
      "Requested billing cycle date cannot be equal to the current billing cycle date. Please enter a valid date to proceed",
    PLSENTERCRCTPAN: "Please enter correct PAN",

    //REKYC Constants
    EMAIL_OTP_MAX_RETRIES:
      "OTP failed! Kindly visit nearest ICICI Bank Branch to update email ID or contact customer care for more details",
    EMAIL_OTP_MAX_RETRIES_DATAQUALITY:
      "OTP failed! Kindly visit nearest ICICI Bank Branch or contact customer care for more details",
    EMAIL_CONTINUE_CONFIRMATION:
      "Do you wish to continue for KYC update without email update?",

    PROCESS_TIMINGS: "This service is available between 9 AM – 5.30 PM",
    PROCESS_TIMING: "This service is available between 9 AM – 5.30 PM",
    GET_TEXT: "Get your",
    SERVICE_TEXT: "Services",
    SERVICE_TEXT_CONTINUE: "in 3 simple steps.",
    NECESSARY_INFO_TEXT:
      "Lets begin with some necessary information and get you started",
    MOB_NUMBER: "Mobile Number",
    PERMANENT_ACCOUNT_NUMBER: "Permanent Account Number",
    OR_TEXT: "OR",
    DOB_TEXT: "DOB (Date of Birth)",

    SUBMIT_DETAILS_TEXT:
      "By submitting my details, I override my DNC/NDNC  registration and  authorise ICICI Bank and its representatives  to  contact  me  through call, WhatsApp, sms, other  messaging, social media platforms  or  E-mail. I  further  consent  to share my information on confidential basis with third parties for evaluating and processing this proposal. ICICI Bank will be sending OTP on the above mentioned number.",
    DATE_OF_BIRTH_TEXT: "Enter Date of Birth",
    REKYC_API_ERROR:
      "Sorry, your transaction could not be completed, please try again later.",
    ESIGN_AUTH_ERROR:
      "Your e-sign authentication has failed, kindly visit the nearest ICICI Bank Branch to update your KYC or contact our Customer Care, for more details.",
    REKYC_SESSION_EXPIRED:
      "Session Expired. Sorry, your transaction could not be completed, please try again later.",
    PAN_DO_NOT_MATCH:
      'Your PAN Name does not match with the bank records. Kindly visit the nearest ICICI Branch to update KYC details.',
    AADHAAR_DIGIT_ERROR: "Please enter your 12-digit valid Aadhaar number.",
    GEOLOCATION_CHECK:
      "Your KYC update request, through Video KYC, can be processed once you are in India. Please contact our Customer Care for more details.",
    EMAIL_OTP_ERROR:
      "The OTP which you have entered is incorrect. Please enter correct OTP or select “Resend OTP” option",
    INVALID_ADHAR_AFTER_API: "Please enter your 12 digit valid Aadhaar number",

    TRANSACTION_SELECTED_TEXT: "transaction selected for EMI conversion",
    TRANSACTIONS_SELECTED_TEXT: "transactions selected for EMI conversion",
    NOTE_TEXT: "Notes : ",
    NOTE_1:
      "1. EMI amount shown above consists of principal and interest components only.",
    NOTE_2:
      "2. EMI amount does not include processing fee.Processing fee will be charged only once at the time of EMI conversion and will reflect in your current Credit Card statement.",
    NOTE_3:
      "3. Foreclosure fee will be charged at 3% on the outstanding principal along with next month interest at the time of foreclosure.",
    NOTE_4:
      "4. Goods and Services Tax (GST) will be levied at 18% on fees, interest and other charges.",
    NOTE_5:
      "5. Cash, fuel and jewelry transactions are not eligible for conversion into EMI.",
    NOTE_6:
      "6. Transactions on commercial/ business cards will not be converted into EMI.",
    CARD_NUMBER: "Card No",
    RATE_OF_INTEREST: "Rate Of Interest",
    PROCESSING_FEE: "Processing Fees",
    TOTAL_EMI_AMOUNT: "Total EMI Amount",
    FORECLOSURE_FEE: "Foreclosure fee : 3%",
    TOTAL_TRANSACTION_AMOUNT: "Total Transaction amount",
    EMAIL_NULL_UPDATE:
      "Email updation failed. Please visit nearest ICICI Bank branch to update your Email-ID.",
    DECLARATION1:
      'I/We understand that Bank is relying on this information for determining my status in FATCA/CRS compliance and understand that the Bank is unable to offer any tax advice or FATCA/CRS status or its impact.',
    DECLARATION2:
      'I / We agree to submit a new form within 30 days if any certification or information in the FATCA/CRS becomes incorrect.',
    DECLARATION3:
      'I am further aware that as per the Union Budget, 2023, a penalty of Rs. 5,000 per account holder shall be levied for furnishing inaccurate statement of financial transaction owing to false or inaccurate self-certification submitted by me under FATCA/CRS',
    OUTSIDE_INDIA:
      'Since you are tax resident of country outside India or an US Person, please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details',
      PAN_ERROR_STATUS:'Dear customer, We are unable to proceed ahead due to Name mismatch with bank records. Kindly visit branch to complete your KYC.',
      INVALID_PAN_DOG:'Invalid PAN. Kindly visit branch to complete your KYC.',
      INVALID_PAN:'Dear Customer, We are unable to proceed ahead due to invalid PAN.',
      NAME_INCORRECT:'We are unable to proceed ahead due to Name mismatch in PAN with NSDL. Kindly re-try to complete your KYC.',
      EXEED_TRYCOUNT: 'We are unable to process your request as your Aadhaar and PAN name do not match. Please visit the nearest branch with physical KYC documents for account conversion',
      NAME_N_ERROR:'Kindly visit the nearest ICICI Branch to update your details.',
      PAN_DOB_MISMATCH_ERROR: 'Date of Birth mismatch in PAN with NSDL. Kindly visit branch to complete your KYC.',
      PAN_NAME_DOB_MISMATCH_ERROR: 'Name and Date of Birth mismatch in PAN with NSDL. Kindly visit branch to complete your KYC., Kindly visit nearest branch.',
      PAN_NAME_MISMATCH:'Dear customer, We are unable to proceed ahead due to Name mismatch in PAN with NSDL. Kindly re-try or visit branch to complete your KYC.',
      PAN_DOB_MISMATCH:'Dear customer, We are unable to proceed ahead due to Date of Birth mismatch in PAN with NSDL. Kindly visit branch to complete your KYC.',
      PAN_NAME_DOB_MISMATCH:'Dear customer, We are unable to proceed ahead due to Name and Date of Birth mismatch in PAN with NSDL. Kindly visit branch to complete your KYC.',
      PAN_VALIDATION_ERROR_STATUS:'Dear customer, We are unable to proceed ahead due to Name mismatch with bank records. Kindly visit branch to complete your KYC.',
    OTP_FAILED_THRICE_GENERIC:
      "OTP failed! Kindly visit nearest ICICI Bank Branch or contact customer care for more details",
    FATCA_GENERIC:
      "Please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details",
    FATCA_RESIDENCE_ERROR:
      "As you have selected your ‘Country of current residence’ other than India, please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details",
    FATCA_BIRTHCOUNTRY_ERROR:
      "As you have selected ‘Country of birth’ other than India, please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details",
    FATCA_CITIZENSHIP_ERROR:
      "As you have selected your ‘Country of citizenship’ other than India, please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details",
    FATCA_TAXCOUNTRY_ERROR:
      "As you have selected your ‘Country of residence for tax purposes’ other than India, please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details",
    FATCA_CURRENT_RESIDENTIAL_ERROR:
      "Since you are not a Resident Indian, please visit the nearest ICICI Bank Branch to update your FATCA and KYC details or contact our Customer Care, for more details.",
    FATCA_USCITIZEN_ERROR:
      "Since you are a US Citizen, Please visit nearest ICICI Bank branch to update your FATCA and KYC details or contact our customer care for more details.",
    LOCATION_ACCESS_ENABLE_GUIDE: [
      'Your location permission is blocked for entered website. Please provide location access to proceed further. Please follow the below guidelines:',
      'Laptop/PC:',
      'Chrome Settings >> Privacy and Security >> Site Settings >> Permissions >> Location >> Select Enable/Allow for https://service.icicibank.com',
      'Mobile Device (Android):',
      'Settings >> Site Settings/App Settings >> Permissions >> Location >> Chrome >> Enable/Allow for https://service.icicibank.com',
      'Mobile Device (iOS):',
      'Settings >> Safari >> Location >> Allow',
    ],
    LOCATION_ERROR: "",
    AADHAAR_EKYC_AUTH_FAILED: 'Your e-KYC authentication has failed!',
    AADHAR_INVALID_RESPONSE: 'Please enter your 12-digit valid Aadhaar number.',
    AADHAAR_EKYC_AUTH_FAIL_MESSAGE_REKYC:
      "Your Aadhaar details did not match with the details registered with the Bank. Please contact ICICI Bank's Customer Care for KYC updates.",
    AADHAAR_EKYC_AUTH_FAIL_MESSAGE:
      "Your Aadhaar details did not match with the details registered with the Bank. Please contact ICICI Bank's Customer Care for KYC updates or update your KYC through the 'Document upload' option.",
    AADHAAR_EKYC_AUTH_FAIL_MESSAGE_OK_KYC:
      "Your e-KYC authentication has failed! Your Aadhaar details did not match with the details registered with the Bank. Please contact ICICI Bank's Customer Care for KYC updates",
    AADHAAR_EKYC_AUTH_FAIL_MESSAGE_OK:
      "Your E-KYC Authentication is failed! kindly visit nearest ICICI Bank branch to submit your KYC document or contact customer care for further process.",
    AADHAAR_ADDRESS_NOTE:
      "Under E-KYC authentication, your Aadhaar address will be updated as a permanent address, mandatorily in our Bank records.",
    PAN_NO_MATCH_ERROR: "PAN does not match",
    PAN_NOT_EXIST_ERROR: "PAN does not exist",
    PAN_INVALID_ERROR: "Invalid PAN",
    EMAIL_INVALID_ERROR:
      "The E-mail ID that you have entered is invalid. Please check the details and try again.",
    EXIT_CONFIRM: "Are you sure you want to exit?",

    SELECT_MANDATORY_FIELDS: "Please select all Mandatory fields",
    TERM_CONDITIONS_ERROR: "Please accept Terms & Conditions",
    CONSENT_ERROR: "Please select the 'Consent' checkbox, to proceed further.",
    DECLARATION_ERROR:
      "Please select the 'Declaration' checkbox, to proceed further.",
    UPDATE_PAN_API_ERROR:
      "PAN verification failed, Kindly visit nearest ICICI Bank Branch to update PAN or contact customer care for more details",
    UPDATE_PAN_CRITICAL_ERROR:
      "You have exceeded the maximum number of attempts to Validate Your PAN. Please try again.",
    AADHAR_OTP_VERIFICATION_ERROR:
      "You have exceeded the maximum number of attempts to Validate Your Aadhar Number. Please try again later.",
    PAN_INPUT_INVALID: "The PAN number that you have entered is invalid.",
    REKYC_ESIGN_RESPONSE_FAIL: "E-sign failed, Please try again",
    ACCOUNT_STATUS_PLACEDUNDERPROCESS:
      "Your KYC request is placed successfully and is under process.",
    ACCOUNT_STATUS_UNDERPROCESS: "Your KYC request is under process.",
    ACCOUNT_STATUS_APPROVEDMESSAGE:
      "Please update your KYC through the 'Document upload' option or call our Customer Care for more details.",
    ACCOUNT_STATUS_REJECTEDMESSAGE_KYC:
      'Your KYC update request through Video KYC, could not be completed. Please call our Customer Care for more details',
    ACCOUNT_STATUS_REJECTEDMESSAGE:
      "Your KYC update request through Video KYC, could not be completed. Please update your KYC through the 'Document upload' option or call our Customer Care for more details.",
    AADHAAR_TERMS:
    "I hereby affirm that I have voluntarily submitted my Aadhaar details to ICICI Bank for conducting the Re-KYC process for my Account held with ICICI Bank and hereby give my consent to ICICI Bank: i) to establish my identity/ address proof through Aadhaar based authentication system or verify the genuineness of the Aadhaar through Quick Response (QR) code or through such other manner, as set out by UIDAI or any other law from time to time; ii) share my Aadhaar details with UIDAI, NPCI, concerned regulatory or statutory authorities, as may be required under applicable laws; iii) also upon authentication, UIDAI may share with ICICI Bank information in the nature of my demographic information, including photograph, which ICICI Bank may use as an identity / address proof, for the above mentioned purpose. I also agree that I have been informed that (a) my Aadhaar details (including my demographic information) shared by UIDAI will not be used for any purpose other than the purpose mentioned above, or as per requirements of law; I hereby declare that all the above information voluntarily furnished by me, is true, correct and complete in all respects and I understand that ICICI Bank shall be relying upon the information received from UIDAI for completing the Re-KYC process for my account.",
    PERMANENT_ADDRESS_DELCARATION:
      "Under E-KYC authentication, your Aadhaar address will be updated as a permanent address, mandatorily in our Bank records.",
    COMMUNICATION_ADDRESS_DECLARATION:
      "I hereby declare that the information provided herein is correct and further authorise ICICI Bank to update my address details in all my linked Bank Account",
    PROFILE_TERMS: [
      "I hereby declare that the information/documents provided are up to date and correct, and further authorize ICICI Bank to update the information provided herein in my bank account.",
      "I agree that this request for KYC update is subject to verification and ICICI Bank reserves the right to reject my application without providing any reason and may choose not to return the documents provided herewith. If incomplete or inaccurate information is given, ICICI Bank reserves the right to ask for additional documents at its sole discretion before processing this KYC update request.",
    ],
    VKYC_TIMINGS_ERROR: "Video KYC is accessible between 7:00 AM to 10:00 PM",
    VALIDDATE: "Please enter valid date,Date should not be prior 90 days",
    // FATCA_ERROR_MSG: "Country selected by you is not mathcing with the tax purpose",
    MANDATE_LIMIT_TEXT: "You can cancel maximum of 5 mandates at a time ",
    MANDATE_SELECTION_TEXT: "mandate selected for cancellation",
    MANDATES_SELECTION_TEXT: "mandates selected for cancellation",
    CONVERTTOEMI:
      "Select and Convert up to 5 transactions into EMI per request (minimum eligibility :Rs.1500/transaction)",
    EDIT: "Edit",
    NOMINEE_MINOR_TEXT: "Nominee is minor. Please enter Guardian Details",
    MODIFY: "Modify",
    SUBMIT: "Submit",
    DELETE: "Delete",
    BACK: "Back",
    PREVIEW_TEXT: "Preview",
    DOWNLOAD_TEXT: "Download",
    CLICK_TEXT: "Click Here",
    DOB_UPDATE_TEXT: "Date of birth already updated in Bank records",
    NRIRESIDENT:
      '"Request for conversion can be place online through ICICI Bank Internet Banking logged in section by using the path Customer Service > Service Requests > Bank Accounts > Request for Conversion of SB Account to NRO Account". Click here (Take the link to RIB login page)',
    PROCESS_REQUEST:
      "Currently we are unable to process request. Please try after sometime.",
    CUSTOMER_TEXT: " Dear Customer,",
    RESEND_LINK_TEXT: "Please wait resending verification link...",
    VERIFICATION_LINK:
      "Verification link has been sent to the your registered email and mobile number.",
    REQUEST_FOR_DELETE_NOMINEE:
      "You have requested for deletion of below nominee in your account",
    ADHAR_DETAILS_TEXT: "Aadhaar details :",
    BANK_DETAILS_TEXT: "Bank details :",
    TRANSTOEMI_SELECTION_TEXT: "Selected transactions for EMI conversion",
    RESEND_OTP: "Resend OTP",
    VERIFY_OTP: "Verifying OTP...",
    FATCA_ERROR_MSG:
      "Please select valid Country of Residence for Tax purpose - it should match with the Country of Current Residence.",
    TIO_FATCA_TAX_ERROR:
      "Please select the correct country of residence for tax purposes",
    OTP_MESSAGE: "Enter 6 Digit OTP",
    MASKED_DEBIT_NO: "Enter pin for this card xxxxxxxxxxxxx97",
    NOTE_MESSAGE_DEBIT:
      " Note: OTP has been generated with validity of 100 seconds and sent to your registered Mobile number If there is a delay in receipt of OTP, you can send a request to receive it. SMS IBOTP to 5676766 or 9215676766. Request should be sent from the mobile number registered in our records Please do not share OTP with anyone, even if the person claims to be an ICICI Bank official. For further details please click here.",
    PIN_NO_MESSAGE: "Enter your ATM pin",
    MOBILE_NO: "Mobile Number :",
    WATSAPP_NOTIFICATON: "Failed to send notification on Whatsapp",
    DTAA_FORM_TEXT: " Steps to fill online 10F form:",
    TERMS_CONDITIONS: "Terms and Conditions",
    SELECT_CITY: "Please enter city",
    SELECT_YEAR: "Please select year",
    SELECT_MFG: "Please selcect Mfg",
    SELECT_OWNERSHIP: "Please Select Ownership",
    SELECT_VARIENT: "Please select variant",
    SELECT_MODEL: "Please select model",
    SELECT_KILOMETER: "Please enter kilo meters",
    VEHICLE_VALUATION: "Vehicle Valuation",
    VEHICLE_DETAILS: " Enter the Vehicle details",
    ENTER_BUILDING_NAME: "Please enter Building Name",
    ENTER_STREET_NAME: "Please enter street name",
    ENTER_LANDMARK: "Please enter landmark",
    ENTER_PINCODE: "Please enter Pincode",
    ENTER_OTHER_DETAILS: "Please enter other details",
    ENTER_STATE: " Please enter state",
    ENTER_MOBILE_NO: "Please enter mobile number",
    ENTER_EMAIL: "Please enter email",
    VALID_PINCODE: "Please enter valid pincode",
    ALTERNATE_MOBILE_NO: "Alternate Mobile",
    ALTERNATE_EMAIL: "Alternate Email",
    BUILDIND_FLAT_NO: "Building Name/Flat No.",
    STREET_NAME: "Street Name",
    LAND_MARK: "Land Mark",
    CITY: "City",
    NEXT: "Next",
    MULTI_RADIO_NEW:'multiRadioNew',
    I_AGREE: "I Agree",
    TERMS_N_CONDITIONS: "Terms And Conditions",
    FAIL_TRANSACTION_TEXT: "Transaction failed.Please try again",
    PLEASE_TRY_AGAIN_LATER: "Please try again later",
    TRANSACTION_FAILURE: "Transaction Failed",
    THANK_YOU_TEXT: "Thank You",
    PAYMENT_SUCESS: "Your Payment is successful !!!",
    TRANSACTION_ID: "TransactionId :",
    AMOUNT_PAID: "Amount Paid : Rs.",
    DATELIMIT: "selected from and to date should be with in 12 months",
    NOMINEE_MINOR_TEXT: "Nominee is minor. Please enter Guardian Details",
    ENTER_GSTIN_TEXT: "Please enter correct GSTIN",
    STATEERR: 'State does not match with GSTIN entered by you',
    GSTIN_STATECODE_CHANGE_MSG:
      'Change in GSTIN State Code will clear the state name',
    MAX_10_DIGITS_ERROR: "Maximum 10 digits allowed",
    ADD_ON_SAVINGS_ACCOUNT_ERROR:
      "Add-on applicant does not have an ICICI Bank account, please visit your nearest branch",
    ENTER_CORRECT_USERID: "Please enter correct userId",
    ENTER_PAN_NUMBER: "Please enter valid PAN Number",
    ENTER_SR_NUMBER: "Please enter valid SR Number",
    SELECT_REQUEST: "Please Select Request",
    CHOOSE_HERE: "Choose here",
    PROFILE_REQUEST: "PROFILE REQUESTS",
    ADRESS_CHANGE: "Address Change",
    UPDATE_EMPLOYEE_NAME: "Update Employer Name",
    EMAIL_ID_UPDATE: "Update email id",
    PAN_UPDATE: "Permanent Account Number (PAN) Update",
    RESIDENTIAL_STATUS: "Residential Status update",
    FACTA_INFO_UPDATE: "FACTA Information update",
    DOB_CHANGE: "Date of Birth (DOB) change",
    LANDLINE_NO_CHANGE: "Landline number change",
    MARITAL_STATUS_UPDATE: "Marital status update",
    FETCHING_DETAILS_TEXT: "Please wait..we are fetching details",
    LOCATION_TEXT: "Location:",
    IP: "IP:",
    LOCATION_ACCESS: "Your Location access is blocked",
    DENIED_REQUEST: "User denied the request for Geolocation.",
    LOCATION_INFO: "Location information is unavailable.",
    REQUEST_TIMED_OUT: "The request to get user location timed out.",
    UNKNOWN_ERROR: "An unknown error occurred.",
    OUTSTANDING: "Outstanding:",
    STATUS_TEXT: "Status:",
    OVERDUE_TEXT: "Overdue",
    HELP_TO_CELL: "Assist to Sell",
    ENABLE_LOCATION: "Please enable location to move ahead",
    USER_CONSENT: "USER CONSENT FOR DELIVERY OF PRODUCT",
    TRANS_UNION: "TransUnion CIBIL Limited",
    SUBMISSION_REQUEST: "Sub:   Submission of Request and Grant of Consent",
    DEAR_SIR: "Dear Sir,",
    TO_TEXT: "To,",
    SUBMISSION_TEXT:
      'In connection with submission of the application for receiving my credit information offered by TransUnion CIBIL Limited (TU CIBIL) (“Product”) through submission of request form (“Product Request”) through [Insert: Name of the Member] and / or [Insert: Name of the Member’s Consumer(s)] "{"STRIKE WHICHEVER IS NOT APPLICABLE"} "(referred to as the “Agent”) and delivery of the Product to the Agent, I hereby acknowledge and agree to the following:',
    I_AGREE_TEXT: " I Agree",
    NECESSARY_INFO_TEXT:
      "Lets begin with some necessary information and get you started",
    OR_TEXT: "OR",
    DOB_TEXT: "DOB (Date of Birth)",
    SUBMIT_DETAILS_TEXT:
      "By submitting my details, I override my DNC/NDNC  registration and  authorise ICICI Bank and its representatives  to  contact  me  through call, WhatsApp, sms, other  messaging, social media platforms  or  E-mail. I  further  consent  to share my information on confidential basis with third parties for evaluating and processing this proposal. ICICI Bank will be sending OTP on the above mentioned number.",
    DATE_OF_BIRTH_TEXT: "Enter Date of Birth",
    SESSION_TIMEDOUT: "Your session has expired. You will be logged out.",
    CLOSE_WINDOW: "Please close the window.",
    VALIDDATE: "Please enter valid date,Date should not be prior 90 days",
    MANDATE_LIMIT_TEXT: "You can cancel maximum of 5 mandates at a time ",
    MANDATE_SELECTION_TEXT: "mandate selected for cancellation",
    MANDATES_SELECTION_TEXT: "mandates selected for cancellation",
    CONVERTTOEMI:
      "Select and Convert up to 5 transactions into EMI per request (minimum eligibility :Rs.1500/transaction)",
    EMI_LIMIT_TEXT:
      "You can select maximum 5 transactions at a time. To convert more transactions please raise new request.",
    TRANSACTION_SELECTED_TEXT: "transaction selected for EMI conversion",
    TRANSACTIONS_SELECTED_TEXT: "transactions selected for EMI conversion",
    RE_DISPATCH_CC_SELECTED_TEXT: "product selected for Re-dispatch",
    RE_DISPATCH_CCs_SELECTED_TEXT: "products selected for Re-dispatch",
    NOTE_TEXT: "Notes :",
    NOTE_1:
      "1. EMI amount shown above consists of principal and interest components only.",
    NOTE_2:
      "2. EMI amount does not include processing fee.Processing fee will be charged only once at the time of EMI conversion and will reflect in your current Credit Card statement.",
    NOTE_3:
      "3. Foreclosure fee will be charged at 3% on the outstanding principal along with next month interest at the time of foreclosure.",
    NOTE_4:
      "4. Goods and Services Tax (GST) will be levied at 18% on fees, interest and other charges.",
    NOTE_5:
      "5. Cash, fuel and jewelry transactions are not eligible for conversion into EMI.",
    NOTE_6:
      "6. Transactions on commercial/ business cards will not be converted into EMI.",
    GSTIN_NOTE_TEXT:
      "Note: I/We hereby understand and agree that given information of GSTIN with respect to the number and billing address is correct and Bank can update the same in records.",
    AUTODEBITNOTE_1:
      "1.  I hereby authorize ICICI bank to change my repayment mode to auto debit",
    AUTODEBITNOTE_2:
      "2.  I agree and acknowledge that the said account can be used for security mandate and can be used by ICICI bank to recover the outstanding  loan amount.",
    AUTODEBITNOTE_3:
      "3.  I understand that, if immediate EMI cycle is already in process for clearance/payment, then change in the repayment mode shall become effective from subsequent cycle date which will be communicated to me through SMS.",
    AUTODEBITNOTE_4:
      "4.  I understand that change of repayment mode is not permissible for Lease Rental Discounting, Lease Rental Discounting Overdraft, Construction-Linked Builder scheme, Loan againts Property for Educational Institutions, Overdraft & Reimbursement Current Accounts (or any other Escrow repayment account) cases.",
    CARD_NUMBER: "Card No",
    RATE_OF_INTEREST: "Rate Of Interest",
    PROCESSING_FEE: "Processing Fees",
    TOTAL_EMI_AMOUNT: "Total EMI Amount",
    FORECLOSURE_FEE: "Foreclosure fee : 3%",
    TOTAL_TRANSACTION_AMOUNT: "Total Transaction amount",
    GSTIN_ERROR: "Please enter your Valid Travel Card Number",
    GEMSTONE_CARD_MESSAGE:
      "We request you to update your communication address and place this request once the new address is updated in bank records . You may update communication address, using any of the following channels :-Internet Banking or Visit any nearest ICICI Bank branch along with original address proof",
    IBOX_ERROR_MSG: [
      "We request you to update your communication address and place this request once the new address is updated in bank records . You may update communication address, using any of the following channels :-",
      "Internet Banking",
      "Customer care",
      "Visit any nearest ICICI Bank branch alongwith original address proof",
    ],
    CORRECT_STATE_VALUE: "Please Select the State from the Given Dropdown",
    ADDRESS_ERROR_MSG_FOR_CC: [
      `We request you to update your communication address and place this request once the new address is updated in bank records. You may update communication address, using any of the following channels :-${" \n"}`,
      `Internet Banking or any nearest ICICI Bank branch along with original address proof `,
    ],
    IBOX_STATE_MESSAGE:
      "iBOX is a parcel delivery terminal with 24X7 flexible pickup facility. iBOX terminals are located near to our select branches. To know more ",
    TDS_ASSESSMENT_YEAR_NOTE: "Note:",
    TDS_ASSESSMENT_YEAR_MESSAGE1:
      "TDS certificate shall be available only for the periods in which TDS has got deducted. For any clarification or more information in this regard, please call our",
    TDS_ASSESSMENT_YEAR_HYPER_LINK: "24-hour Customer Care",
    TDS_ASSESSMENT_YEAR_MESSAGE2:
      "or contact your Relationship Manager. Alternatively, you may visit your nearest ICICI Bank Branch.",
     FATCA_COUNTRY_ERROR: 'Please select a valid Country of Residence for Tax purpose - it should match with the Country of Current Residence',
    DATE_RANGE_EXCEEDED_ERROR: "Date range cannot be more than one year",
    MAX_THREE_CHARS_ALLOWED: "Max 3 characters are allowed",
    PINCODE_LENGTH_ERROR: "Please enter 6 digit",
    ATM_PIN_ERROR: "Please enter 4 digit",
    VALID_BENEFICIARY_ERROR: "Please enter valid beneficiary Account Number",
    VALID_BENEFICIARY_ACCOUNT_ERROR:
      "Please enter valid beneficiary Account Number",
    VALID_IFSC_ERROR: "Please enter valid IFSC Code",
    ADDRESS_CHANGE_ERROR:
      "Request you to please visit an ICICI Bank Demat servicing branch to update the details. In case you require any further assistance, please call our Customer Care or write to customer.care@icicibank.com",
    VALID_COUNTRY_ERROR: "Please enter valid country name",
    CONVERSION_ERROR:
      "Request for conversion can be place online through ICICI Bank Internet Banking logged in section by using the path Customer Service > Service Requests > Bank Accounts > Request for Conversion of SB Account to NRO Account",
    CANCEL_NO_AVAIL_ERROR: "Account Level Cancellation not available for Card",
    FATCA_VALID_COUNTRY_TAX_ERROR:
      "Please select valid Country of Residence for Tax purpose - it should match with the Country of Current Residence.",
      COUNTRY_CURRENT_RESIDENCE_ERROR:
      "The current country of residence should be India for a resident account holder. In case, your residential status has changed request you to get your account converted.",
    GETDBTPOPUPVALUE:
      "To link Aadhaar Number in savings bank account for receiving DBT, Aadhar Details should match with Bank Account Details",
      DBT_NRI_RESTRICTED_MSG: 'This service is not applicable for NRI/Current account',
      ERROR_TEXT: "Something went wrong",
    AWAIT_MSG:
      "Currently we are unable to process request. Please try after sometime.",
    GET_TEXT: "Get your",
    SERVICE_TEXT: "Services",
    SERVICE_TEXT_CONTINUE: "in 3 simple steps.",
    INFO_TEXT: "Lets begin with some necessary information and",
    START_TEXT: "get you started",
    MOB_NUMBER: "Mobile Number",
    PERMANENT_ACCOUNT_NUMBER: "Permanent Account Number",
    VERIFICATION_LINK_TEXT:
      "By submitting my details, I override my DNC/NDNC registration and authorise ICICI Bank and its representatives to contact me through call, WhatsApp, sms, other messaging, social media platforms or E-mail. I further consent to share my information on confidential basis with third parties for evaluating and processing this proposal. ICICI Bank will be sending verification link on the above mentioned number",
    OTP_TEXT:
      "By submitting my details, I override my DNC/NDNC registration and authorise ICICI Bank and its representatives to contact me through call, WhatsApp, sms, other messaging, social media platforms or E-mail. I further consent to share my information on confidential basis with third parties for evaluating and processing this proposal. ICICI Bank will be sending OTP on the above mentioned number.",
    CUSTOMER_TEXT: " Dear Customer,",
    RESEND_LINK_TEXT: "Please wait resending verification link...",
    VERIFICATION_LINK:
      "Verification link has been sent to the your registered email and mobile number.",
    CLOSE_TEXT: "Close",
    PLACEHOLDER_TEXT: "How Can We Help You?",
    ADDRESS_LINE1: "Enter the Communication Address Line 1",
    ADDRESS_LINE2: "Enter the Communication Address Line 2",
    ADDRESS_LINE3: "Enter the Communication Address Line 3",
    TIN_DETAIL_TEXT: "Enter TIN details",
    CLICK_TEXT: "Click Here",
    DOB_UPDATE_TEXT: "Date of birth already updated in Bank records",
    LISTMANDATES: "List of mandates",
    SEND_DETAIL_FAILURE_TEXT: "Failed to send details.Please try again..",
    PREVIEW_TEXT: "Preview",
    VIEW_TEXT: "View",
    DOWNLOAD_TEXT: "Download",
    DETAILS_TEXT: " Details has been shared successfully",
    FAMILY_TYPE_ERROR_MSG:'You are not eligible for the selected family type, for further details please visit your nearest ICICI Bank Branch or contact customer care.',
    SALARY_TYPE_ERROR_MSG:"Salary Family Banking is not available for your existing account variant. To Opt for this account variant, visit the nearest ICICI Bank Branch or call our Customer Care.",
    FAMILYTYPEERROR:"To be eligible, please ensure that at least one of the family members is an active Account holder in the selected variant. For further details, please visit your nearest ICICI Bank Branch or contact our Customer Care.",
    FAMILY_BANKING_ERROR:
      'These fields are required(*) or Invalid entry, Please re-enter and try again.',

    //CancelAutoDebitMandate
    CANCELMANDATE_PREVIEW_NOTE: 'Notes:',
    CANCELMANDATE_PREVIEW_NOTE_1:
      '1. Mandate cancellation will be processed today',
    CANCELMANDATE_PREVIEW_NOTE_2:
      '2. Auto Debit Mandate once cancelled cannot be restored',

    // pebble
    PEBBLE_ALERT: "ALERT",
    PEBBLE_SUCCESSFUL: "Successful!",
    PEBBLE_CA_ALERT:
      "Please select this variant if you are a practicing Chartered Accountant",
    PEBBLE_DOCTOR_ALERT:
      "Please select this variant if you are a practicing Doctor",
    PEBBLE_SUPER_MERCHANT_ALERT:
      "If your account is linked to an active MID/TID for POS machine or QR or an active UPI ID/QR code than only the you can apply for this variant",
    PEBBLE_REQUEST_SR: "Request Generated!",
    PEBBLE_REQUEST_SUBMITTED: "Your request is submitted successfully.",
    PEBBLE_REQUEST_SUBMITTED_ICE:
      "Your request for new IEC no. is submitted. Further updates on SR status will be shared via SMS",
    PEBBLE_REQUEST_SUBMITTED_CHEQUE:
      "Your request for cheque book enablement/ disablement is submitted. Further updates on SR status will be shared via SMS",
    PEBBLE_UPDATE_EMAIL_PROCESSED:
      "Your request to update E-mail ID has been processed.",
    PEBBLE_UPDATE_EMAIL_REQUEST:
      "Your request form to update Email ID & Mobile Number has been generated",
    PEBBLE_SUBMIT_HARDCOPY_NOTE:
      "Please submit a signed/stamped hardcopy of the file above at your nearest ICICI Bank Branch to complete your request",
    PEBBLE_VARIANT_CHANGE_EFFECT:
      "The change in variant will be effective from 1st of next calendar month.",
    PEBBLE_VARIANT_CHANGE_EFFECT_POST_CONFIRM:
      "The change in variant will be effective from 1st of next calendar month post confirmation.",
    PEBBLE_VARIANT_DIGITAL_MIGRATION_ERROR:
      "Your existing variant cannot be migrated digitally.",
    PEBBLE_VISIT_NEAREST_BRANCH:
      "Please visit nearest ICICI Bank Branch for help",
    PEBBLE_SOMETHING_WENT_WRONG: "Something Went Wrong",
    PEBBLE_DECRYPT_FAILURE:
      "Sorry, your transaction could not be processed, please try again later",
    PEBBLE_GENERIC_ERROR: "Sorry, there was an error.",
    PEBBLE_INACTIVE_ERROR:
      "Session expired! You have been inactive for too long.",
    PEBBLE_GENERIC_ERROR_MSG: "Request Unsuccessful",
    PEBBLE_GENERIC_ERROR_DETAIL:
      "Due to some technical issue we couldn’t complete your request please try after some time.",
    FATCA_ERROR_MSG:
      "Please select valid Country of Residence for Tax purpose - it should match with the Country of Current Residence.",
    PEBBLE_AMOUNT_INSUFFICENT_ERROR:
      "Request cannot be processed due to insufficient funds in account.",
    PEBBLE_NOT_ALLOWED_ERROR: "Kindly visit branch for processing this request",
    PEBBLE_PAYSLIP_SELECT_CUSTOMERS:
      "The Selected option is Digitally available only for select customers. Kindly Visit your nearest ICICI Bank branch to Avail this service",
    PEBBLE_MAX_EXCEEDS: {
      heading:
        "You have exceeded the maximum number of attempts to enter the correct Debit Grid details.",
      message: " Please try again..!",
      detail: "You will be redirected to home page",
    },

    // data quality
    DATAQUALITY_SERVICE_URL: "/servicing/dataQualityProcess",
    DATAQUALITYSUCCESS: "RE-KYC is successful",
    DATAQUALITYFAILED:
      "Sorry, your transaction could not be processed, please try again later",
    CANCELLEDBYUSER:
      "Customer approval not received. Please re-initiate the request.",
    EMAIL_UPDATE_NOTE:
      "Incase of change in Email ID, same will be updated in account(s).",

    EMAIL_OTP_MAX_RETRIES:
      "OTP failed! Kindly visit nearest ICICI Bank Branch to update email ID or contact customer care for more details",
    EMAIL_CONTINUE_CONFIRMATION:
      "Do you wish to continue for KYC update without email update?",

    PROCESS_TIMINGS: "This service is available between 9 AM – 5.30 PM",
    PROCESS_TIMING: "This service is available between 9 AM – 5.30 PM",
    GET_TEXT: "Get your",
    SERVICE_TEXT: "Services",
    SERVICE_TEXT_CONTINUE: "in 3 simple steps.",
    NECESSARY_INFO_TEXT:
      "Lets begin with some necessary information and get you started",
    MOB_NUMBER: "Mobile Number",
    PERMANENT_ACCOUNT_NUMBER: "Permanent Account Number",
    OR_TEXT: "OR",
    DOB_TEXT: "DOB (Date of Birth)",

    SUBMIT_DETAILS_TEXT:
      "By submitting my details, I override my DNC/NDNC  registration and  authorise ICICI Bank and its representatives  to  contact  me  through call, WhatsApp, sms, other  messaging, social media platforms  or  E-mail. I  further  consent  to share my information on confidential basis with third parties for evaluating and processing this proposal. ICICI Bank will be sending OTP on the above mentioned number.",
    DATE_OF_BIRTH_TEXT: "Enter Date of Birth",
    DATAQUALITY_API_ERROR:
      "Sorry, your transaction could not be completed, please try again later.",
    ESIGN_AUTH_ERROR:
      "Your e-sign authentication has failed, kindly visit the nearest ICICI Bank Branch to update your KYC or contact our Customer Care, for more details.",
    DATAQUALITY_SESSION_EXPIRED:
      "Session Expired. Sorry, your transaction could not be completed, please try again later.",
    AADHAAR_DIGIT_ERROR: "Please enter your 12-digit valid Aadhaar number.",
    GEOLOCATION_CHECK:
      "Your KYC update request, through Video KYC, can be processed once you are in India. Please contact our Customer Care for more details.",
    EMAIL_OTP_ERROR:
      "The OTP which you have entered is incorrect. Please enter correct OTP or select “Resend OTP” option",
    INVALID_ADHAR_AFTER_API: "Please enter your 12 digit valid Aadhaar number",
  },
  PEBBLE_EMM: {
    COMMUNICATION_LABEL: "Communication Contact Details ",
    ALERT_LABEL: "Alert Contact Details ",
    TRADE_ALERT_LABEL: "Trade Alert Contact Details ",
    STATEMENTS_LABEL: "For Account Statements",
    STATEMENTS_LABEL_TEMP: "Account Statements Info",
    IBANKING_LABEL: "Corporate internet Banking Contact Details",
  },
  PEBBLE_DEMOGRAPHIC: {
    IEC_LABEL: "Importer Exporter Code (IEC) No.",
    IEC_DESC:
      "An Importer-Exporter Code (IEC) is a business identification number which is mandatory for Export from India or Import to India. No export or import is permitted without obtaining an IEC unless specifically exempted.",
    LEI_LEBEL: "Legal Entity Identifier (LEI)",
    LEI_DESC:
      "The Legal Entity Identifier (LEI) is a unique 20-digit code that identifies every legal entity, in any jurisdiction, that is party to a financial transaction. Transactions value of Rs <50> crore and above undertaken by entities through RTGS and NEFT need LEI number.",
    CHEQUEBOOK_LABEL: "Cheque Book",
    CHEQUEBOOK_DESC:
      "The facility of Cheque book can be enabled or disabled by the customer for their Account.",
    GST_LABEL: "GST Details",
    GST_DESC:
      "The Goods and Services Tax Identification Number (GSTIN) is a 15-digit alphanumeric unique identification number provided to a taxpayer, who gets registration under the GST Law.",
    CASH_LIMIT_LABEL: "Cash Limit",
    CASH_LIMIT_DESC:
      "Current Cash Deposit and Cash Withdrawal limits can be viewed using the below option.",
    AS_LABEL: "Authorized Signatory",
    BO_LABEL: "Beneficial Owner",
    AS_BO_LABEL: "Authorized Signatory/Beneficial Owner Details",
  },
  SESSION_EXPIRED: {
    msg1: "Your session has been expired...!",
    msg2: "Please close the window and try again",
  },
  SOMETHING_WRONG: {
    msg1: "Something Went Wrong",
    msg2: "",
  },
  SESSION_ALREADY_OPEN: {
    msg1: "Previous session is already open...!",
    msg2: "Please close the window and try again ",
  },
  UNABLE_PROCEED: {
    msg1: " Sorry...! Unable to proceed the link ",
    msg2: " Please try again ",
  },
  CANNOTPROCEED: {
    msg1: "Cannot Proceed link has expired...!",
    msg2: "Please try again",
  },
  PlEASECLOSE_REDIRECT: {
    msg1: "Happy to serve you",
    msg2: "Please close the window",
  },


  
};
